import React from 'react';
import type { SearchInputModel } from '../../type/buttons';
import './searchInput.scss';


const SearchInput: React.FC<SearchInputModel> = ({ 
  value, 
  onChange, 
  placeholder = "Search...",
  className = ""
}) => {
  return (
    <div className={`search-input ${className}`}>
      <div className="input-group">
        <span className="input-group-text">
          <i className="bi bi-search"></i>
        </span>
        <input
          type="text"
          className="form-control"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        {value && (
          <button
            className="btn btn-outline-secondary"
            type="button"
            onClick={() => onChange('')}
            title="Clear search"
          >
            <i className="bi bi-x-lg"></i>
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchInput;